export const CarMakerDemoColumns = [
    { field: 'manufacturer', headerName: 'Manufacturer', width: 180, editable: false, sortable: false },
    { field: 'domain', headerName: 'Domain', width: 180, editable: false, sortable: false },
    { field: 'status', headerName: 'Status', width: 180, editable: false, sortable: false },
    { field: 'version', headerName: 'Version', width: 180, editable: false, sortable: false },
    { field: 'region', headerName: 'Region', width: 180, editable: false, sortable: false },
    { field: 'model', headerName: 'Model', width: 180, editable: false, sortable: false },
    { field: 'entityID', headerName: 'Entity ID', width: 180, editable: false, sortable: false },
];

export const CarMakerDemoRows = [
    {
        id: 1,
        manufacturer: "ford",
        domain: "sales",
        status: "completed",
        version:"v1.3",
        region: "northAmerica",
        model: "F-150",
        entityID: "a1001",
    },
    {
        id: 2,
        domain: "inventory",
        status: "updated",
        version: "v2.0",
        region: "europe",
        model: "explorer",
        entityID: "a1002",
    },
    {
        id: 3,
        domain: "services",
        status: "scheduled",
        version: "v3.4",
        region: "asia",
        model: ">",
        entityID: "a1003",
    },
    {
        id: 4,
        domain: "customerFeedback",
        status: "launched",
        version: "v4.1",
        region: "southAmerica",
        model: "ranger",
        entityID: "a1004",
    },
    {
        id: 5,
        domain: "marketing",
        status: "submitted",
        version: "v13.5",
        region: "australia",
        model: "escape",
        entityID: "a1005",
    },
    {
        id: 6,
        domain: "support",
        status: "*",
        model: "focus",
        entityID: "a1006",
    },
    {
        id: 7,
        status: "resolved",
        entityID: "a1007",
    },
    {
        id: 8,
        status: "received",
        entityID: "a1008",
    },
    {
        id: 9,
        status: "processed",
        entityID: "a1009",
    },
    {
        id: 10,
        entityID: "a1010",
    }

];
